import { useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Play } from "lucide-react";
import { IMAGES } from "../data/content";

export function VideoPlayer({ poster }) {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const containerRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.08, 1, 1.08]);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setPlaying(true);
    }
  };

  return (
    <div
      ref={containerRef}
      data-testid="cinematic-video-player"
      className="relative aspect-video w-full overflow-hidden border border-white/10 bg-black"
    >
      <motion.video
        ref={videoRef}
        style={{ scale: playing ? 1 : scale }}
        className="h-full w-full object-cover"
        poster={poster || IMAGES.orRoom}
        controls={playing}
        playsInline
        preload="none"
        onPause={() => setPlaying(false)}
        onPlay={() => setPlaying(true)}
      >
        <source src={IMAGES.video} type="video/mp4" />
      </motion.video>

      {!playing && (
        <button
          data-testid="video-play-button"
          onClick={handlePlay}
          className="absolute inset-0 flex flex-col items-center justify-center bg-ink/40 transition-colors duration-300 hover:bg-ink/25"
        >
          <span className="group relative flex h-24 w-24 items-center justify-center">
            <span className="absolute inset-0 animate-ping rounded-full bg-crimson/30" />
            <span className="relative flex h-20 w-20 items-center justify-center rounded-full bg-crimson transition-transform duration-300 group-hover:scale-110">
              <Play className="h-7 w-7 translate-x-0.5 fill-white text-white" />
            </span>
          </span>
          <span className="mt-6 font-mono text-xs uppercase tracking-[0.3em] text-white">
            Watch · Tips & Tricks in Difficult BMV
          </span>
        </button>
      )}
    </div>
  );
}
